export const StepBack = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.625 2.70825L3.125 5.20825L5.625 7.70825M3.75 5.20825H11.875C14.7515 5.20825 17.0833 7.5401 17.0833 10.4166C17.0833 13.2931 14.7515 15.6249 11.875 15.6249H4.79167"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default StepBack
